import * as React from 'react';
import { ScrollFade } from '../../ScrollFade';
import * as styles from './TgbStretchTemplate.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var TgbStretchTemplate = function TgbStretchTemplate(props) {
  var bgImageUrl = props.bgImageUrl,
    title = props.title,
    description = props.description,
    phone = props.phone,
    address = props.address,
    note = props.note,
    url = props.url,
    label = props.label;
  return /*#__PURE__*/_jsx("a", {
    href: url,
    target: "_blank",
    rel: "noreferrer noopener nofollow",
    className: styles['link'],
    children: /*#__PURE__*/_jsxs("div", {
      className: styles['container'],
      children: [/*#__PURE__*/_jsx("div", {
        className: styles['image'],
        children: /*#__PURE__*/_jsx("img", {
          src: bgImageUrl,
          alt: title
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: styles['aside'],
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles['content'],
          children: [/*#__PURE__*/_jsx("h4", {
            className: styles['title'],
            children: title
          }), /*#__PURE__*/_jsx("p", {
            className: styles['text'],
            children: description
          }), phone && /*#__PURE__*/_jsx("div", {
            className: styles['phone'],
            children: phone
          }), address && /*#__PURE__*/_jsx("div", {
            className: styles['address'],
            children: address
          })]
        }), note && /*#__PURE__*/_jsxs("div", {
          className: styles['note'],
          children: [note, /*#__PURE__*/_jsx(ScrollFade, {
            size: 18
          })]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: styles['advanced'],
        children: [/*#__PURE__*/_jsx("span", {
          children: label
        }), /*#__PURE__*/_jsx("span", {
          children: "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435"
        })]
      })]
    })
  });
};